module.exports = __webpack_public_path__ + "static/media/money-bill.12e8b046.svg";